import { createFileRoute } from "@tanstack/react-router";

import { OpenSourceLicensesPanel } from "../components/settings/OpenSourceLicenses";

export const Route = createFileRoute("/_pages/licenses")({
  component: OpenSourceLicensesPanel,
});
